/*! formidable-a11y.js — Accessibilité Formidable Forms (Gutenberg)
 *  Ajoute : focus visible, fieldset/legend, ARIA, autocomplete, erreurs, hCaptcha, messages de statut.
 *  Auteur: ChatGPT — 2025-08-26
 */
(function () {
  'use strict';

  // =========================
  // Utils
  // =========================
  var CSS_ID = 'nr-formidable-a11y-style';
  var FIELDSET_CLASS = 'frm-group-identite';
  var LEGEND_ID_PREFIX = 'legend-identite-';

  function injectCSSOnce() {
    if (document.getElementById(CSS_ID)) return;
    var style = document.createElement('style');
    style.id = CSS_ID;
    style.textContent = [
      /* Focus bien visible (bleu) */
      ':where(.frm_forms) :where(input, select, textarea, button, .frm_button_submit):focus,',
      ':where(.frm_forms) :where(input, select, textarea, button, .frm_button_submit):focus-visible{',
      '  outline:2px solid #1a73e8;',
      '  outline-offset:2px;',
      '}',

      /* Remet à zéro des éventuels box-shadow intrusifs */
      ':where(.frm_forms) :where(input, select, textarea, button, .frm_button_submit){',
      '  box-shadow:none !important;',
      '}',

      /* Étoile obligatoire */
      '.req-star{color:#c00;font-weight:600;}',

      /* Visibilité des erreurs s’il faut forcer (optionnel) */
      '.frm_error, .frm_error_style{display:block !important;}',

      /* Masquer le pot de miel anti-spam */
      '#frm_field_16_container{',
      '  position:absolute !important;',
      '  left:-9999px !important;',
      '  width:1px !important;',
      '  height:1px !important;',
      '  overflow:hidden !important;',
      '}',

      /* Style des fieldsets RGAA */
      '.frm_forms fieldset{',
      '  border:none;',
      '  padding:0;',
      '  margin:0 0 1.5em 0;',
      '}',
      '.frm_forms legend{',
      '  font-size:1.2em;',
      '  font-weight:600;',
      '  margin-bottom:1em;',
      '  padding:0;',
      '}',
    ].join('\n');
    document.head.appendChild(style);
  }

  // --- Utils robustes pour accepter Element / Document / jQuery / NodeList / Array ---
  function normalizeRoots(root) {
    if (!root) return [document];
    // Element ou Document
    if (root.nodeType === 1 || root.nodeType === 9) return [root];
    // jQuery object
    if (typeof jQuery !== 'undefined' && root instanceof jQuery) return root.get();
    // NodeList / HTMLCollection / Array-like d'Elements
    if (Array.isArray(root)) return root.filter(function (n) { return n && (n.nodeType === 1 || n.nodeType === 9); });
    if (root.length && (root[0]?.nodeType === 1 || root[0]?.nodeType === 9)) return Array.prototype.slice.call(root);
    // fallback
    return [document];
  }

  function $(root, sel) {
    var roots = normalizeRoots(root);
    for (var i = 0; i < roots.length; i++) {
      var el = roots[i].querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function $all(root, sel) {
    var roots = normalizeRoots(root);
    var out = [];
    for (var i = 0; i < roots.length; i++) {
      out = out.concat(Array.prototype.slice.call(roots[i].querySelectorAll(sel)));
    }
    return out;
  }


  // Match FR label by includes
  function findInputByLabelFragment(form, fragment) {
    var frag = (fragment || '').toLowerCase();
    var labels = $all(form, 'label');
    for (var i = 0; i < labels.length; i++) {
      var ltxt = labels[i].textContent.trim().toLowerCase();
      if (ltxt.includes(frag)) {
        var forId = labels[i].getAttribute('for');
        if (forId) {
          var target = $('#' + CSS.escape(forId));
          if (target) return target;
        } else {
          var inside = labels[i].querySelector('input, select, textarea');
          if (inside) return inside;
        }
      }
    }
    return null;
  }

  function ensureId(el, base) {
    if (!el) return null;
    if (!el.id) el.id = (base || 'id-') + Math.random().toString(36).slice(2);
    return el.id;
  }

  // =========================
  // Erreurs & Messages
  // =========================
  function attachErrorARIA(form) {
    // Per-champ
    $all(form, '.frm_form_field').forEach(function (wrap) {
      var input = wrap.querySelector('input, select, textarea');
      if (!input) return;

      var err = wrap.querySelector('.frm_error, .frm_error_style');
      if (!err) return;

      ensureId(input, 'fld-');
      ensureId(err, input.id + '-error-');

      // Rôle & live region
      err.setAttribute('role', 'alert');
      err.setAttribute('aria-live', 'assertive');

      // Lier au champ
      var current = (input.getAttribute('aria-describedby') || '').trim().split(/\s+/).filter(Boolean);
      if (current.indexOf(err.id) === -1) {
        current.push(err.id);
        input.setAttribute('aria-describedby', current.join(' '));
      }
      input.setAttribute('aria-invalid', 'true');

      // Exemples FR (email/tel) si le texte ne contient pas déjà "ex."
      var txt = err.textContent || '';
      if (input.type === 'email' && !/ex\./i.test(txt)) {
        err.textContent = 'Renseignez une adresse e-mail valide (ex. nom@domaine.fr)';
      }
      var isTel = input.type === 'tel' || /tel|phone/i.test(input.name || '');
      if (isTel && !/ex\./i.test(err.textContent || '')) {
        err.textContent = 'Renseignez un numéro de téléphone valide (ex. 01 23 45 67 89)';
      }
    });

    // Message global succès
    $all(form, '.frm_message, #frm_message, .frm_success_style').forEach(function (msg) {
      msg.setAttribute('role', 'status');
      msg.setAttribute('aria-live', 'polite');
    });

    // Message global erreur
    $all(form, '.frm_error_global').forEach(function (msg) {
      msg.setAttribute('role', 'alert');
      msg.setAttribute('aria-live', 'assertive');
    });
  }

  // =========================
  // Radiogroup & Checkbox groups
  // =========================
  function markRadioGroups(form) {
    $all(form, '.frm_form_field').forEach(function (wrap) {
      var radios = $all(wrap, 'input[type="radio"]');
      if (!radios.length) return;

      // Conteneur des options
      var group = wrap.querySelector('.frm_opt_container') || wrap;
      var label = wrap.querySelector('label');
      if (label) ensureId(label, 'lbl-');
      group.setAttribute('role', 'radiogroup');
      if (label) {
        group.setAttribute('aria-labelledby', label.id);
      } else {
        group.setAttribute('aria-label', 'Choix');
      }
    });
  }

  // =========================
  // Simplifier RGPD : checkbox unique sans wrapper group
  // =========================
  function simplifyRGPDCheckbox(form) {
    var rgpdContainer = $(form, '#frm_field_12_container');
    if (!rgpdContainer) return;

    // Supprimer le wrapper role="group" inutile pour une checkbox unique
    var optContainer = rgpdContainer.querySelector('.frm_opt_container[role="group"]');
    if (optContainer) {
      optContainer.removeAttribute('role');
      optContainer.removeAttribute('aria-labelledby');
    }

    // Supprimer le label "RGPD" redondant
    var rgpdLabel = rgpdContainer.querySelector('#field_rgpd_label');
    if (rgpdLabel) {
      rgpdLabel.style.display = 'none';
    }
  }

  // =========================
  // Fieldsets sémantiques conformes RGAA - Version dynamique
  // Détecte automatiquement les sections Formidable Forms et crée des fieldsets
  // Respecte les regroupements définis par l'utilisateur
  // =========================
  function createProperFieldsets(container) {
    if (!container) return;
    if (container.dataset.frmFieldsetsProcessed) return;
    container.dataset.frmFieldsetsProcessed = 'true';

    var formEl = container.querySelector('form');
    if (!formEl) return;

    // 1. Supprimer le fieldset wrapper global s'il existe
    var globalFieldset = formEl.querySelector('fieldset');
    if (globalFieldset) {
      var fieldsContainer = globalFieldset.querySelector('.frm_fields_container');
      if (fieldsContainer) {
        // Extraire le contenu du fieldset global
        while (fieldsContainer.firstChild) {
          globalFieldset.parentNode.insertBefore(fieldsContainer.firstChild, globalFieldset);
        }
        globalFieldset.parentNode.removeChild(globalFieldset);
      }
    }

    // 2. Détecter toutes les sections définies par l'utilisateur
    var sections = $all(formEl, '.frm_section_heading');

    if (sections.length === 0) {
      // Pas de sections = pas de fieldsets (l'utilisateur n'a pas voulu regrouper)
      return;
    }

    // 3. Pour chaque section, créer un fieldset avec les champs associés
    sections.forEach(function(section, index) {
      // Récupérer le titre h3 pour la legend
      var heading = section.querySelector('h3');
      if (!heading) return;

      var legendText = heading.textContent.trim();
      if (!legendText) return;

      // Récupérer l'ID de la section depuis data-sectionid ou l'ID du container
      var sectionId = null;
      var sectionIdMatch = section.id.match(/field_([^_]+)_container/);
      if (sectionIdMatch) {
        sectionId = sectionIdMatch[1];
      }

      // Trouver tous les champs de cette section
      // Méthode 1 : via data-sectionid (si présent sur les inputs)
      var fieldsWithSectionId = [];
      if (sectionId) {
        var inputsWithSectionId = $all(formEl, '[data-sectionid="' + sectionId + '"]');
        fieldsWithSectionId = inputsWithSectionId.map(function(input) {
          var field = input;
          while (field && field !== formEl && !field.classList.contains('frm_form_field')) {
            field = field.parentNode;
          }
          return field && field.classList.contains('frm_form_field') ? field : null;
        }).filter(function(f) { return f; });
      }

      // Méthode 2 : récupérer tous les champs enfants directs de la section
      var childFields = Array.prototype.slice.call(section.children).filter(function(child) {
        return child.classList && child.classList.contains('frm_form_field') && 
               !child.classList.contains('frm_section_heading');
      });

      // Combiner les deux méthodes et dédupliquer
      var allFields = fieldsWithSectionId.concat(childFields);
      var uniqueFields = [];
      var seen = new Set();
      allFields.forEach(function(field) {
        if (field && !seen.has(field)) {
          seen.add(field);
          uniqueFields.push(field);
        }
      });

      if (uniqueFields.length === 0) {
        // Pas de champs = pas de fieldset pour cette section
        section.parentNode.removeChild(section);
        return;
      }

      // Créer le fieldset
      var fieldset = document.createElement('fieldset');
      fieldset.className = 'frm_fields_container frm-fieldset frm-fieldset-section-' + (sectionId || index);

      var legend = document.createElement('legend');
      legend.textContent = legendText;
      fieldset.appendChild(legend);

      // Insérer le fieldset à la place de la section
      section.parentNode.insertBefore(fieldset, section);

      // Déplacer tous les champs dans le fieldset
      uniqueFields.forEach(function(field) {
        fieldset.appendChild(field);
      });

      // Supprimer la section maintenant vide
      section.parentNode.removeChild(section);
    });

    // 4. Supprimer les titres HTML décoratifs redondants qui pourraient rester
    $all(formEl, '.frm_html_container').forEach(function(el) {
      var text = (el.textContent || '').trim();
      var parent = el.parentNode;

      // Vérifier si ce titre correspond à une legend de fieldset existante
      if (parent && parent.tagName === 'FIELDSET') {
        var legend = parent.querySelector('legend');
        if (legend && legend.textContent.trim() === text) {
          el.parentNode.removeChild(el);
        }
      }
    });
  }

  // =========================
  // hCaptcha liens
  // =========================
  function enhanceHCaptchaLinks(scope) {
    $all(scope, 'a[href*="hcaptcha.com"]').forEach(function (a) {
      var txt = (a.textContent || '').trim();
      var low = txt.toLowerCase();
      if (low.includes('confidentialit') || low.includes('privacy') || low.includes('conditions') || low.includes('terms')) {
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener');
        var dest = a.getAttribute('href') || '';
        a.setAttribute('aria-label', (txt || 'Lien hCaptcha') + ' — s’ouvre dans un nouvel onglet. Destination : ' + dest);
      }
    });
  }

  // =========================
  // Liens nouvel onglet : nom accessible + mention de l'ouverture
  // Ordre de priorité : aria-label, title, texte du lien, alt de l'image (liens-images)
  // =========================
  function labelBlankLinks(scope) {
    $all(scope, 'a[target="_blank"]').forEach(function (a) {
      if (a.dataset.blankLabelled) return;
      a.dataset.blankLabelled = 'true';

      var label = (a.getAttribute('aria-label') || '').trim()
        || (a.getAttribute('title') || '').trim()
        || (a.textContent || '').trim();

      if (!label) {
        var img = $all(a, 'img[alt]').filter(function (i) { return i.alt.trim(); })[0];
        if (img) label = img.alt.trim();
      }

      a.setAttribute('aria-label', label + ' - Ouvre dans un nouvel onglet');
    });
  }

  // =========================
  // Principal : améliore un formulaire Formidable
  // =========================
  function enhanceFormContainer(container) {
    if (!container) return;

    var formEl = container.querySelector('form');
    if (formEl) formEl.setAttribute('autocomplete', 'on');

    // 1) Bouton submit : ne pas ajouter aria-label si texte visible déjà présent
    var submit = container.querySelector('button[type="submit"], input[type="submit"], .frm_button_submit');
    if (submit) {
      var visibleText = (submit.tagName === 'BUTTON') ? (submit.textContent || '').trim() : ((submit.value || '').trim());
      // Aria-label uniquement si pas de texte visible
      if (!visibleText) {
        submit.setAttribute('aria-label', 'Envoyer ma demande');
      } else if (submit.hasAttribute('aria-label') && submit.getAttribute('aria-label') === visibleText) {
        // Supprimer aria-label redondant
        submit.removeAttribute('aria-label');
      }
    }

    // 1b) Corriger le label du captcha
    var captchaLabel = container.querySelector('label[for="h-captcha-response"]');
    var captchaWidget = container.querySelector('.h-captcha');
    if (captchaLabel && captchaWidget) {
      // Créer un wrapper avec role="group" pour le captcha
      var captchaWrapper = document.createElement('div');
      captchaWrapper.setAttribute('role', 'group');
      captchaWrapper.setAttribute('aria-labelledby', captchaLabel.id || 'captcha-label');

      if (!captchaLabel.id) {
        captchaLabel.id = 'captcha-label';
      }

      captchaLabel.removeAttribute('for');
      captchaLabel.querySelector('.frm_required')?.remove();

      captchaWidget.parentNode.insertBefore(captchaWrapper, captchaWidget);
      captchaWrapper.appendChild(captchaWidget);
    }

    // 2) Champs requis : étoile + aria-required
    $all(container, '.frm_form_field').forEach(function (wrap) {
      var input = wrap.querySelector('input, select, textarea');
      var label = wrap.querySelector('label');
      if (!input || !label) return;
      if (input.required) {
        if (!label.querySelector('.req-star')) {
          var star = document.createElement('span');
          star.className = 'req-star';
          star.setAttribute('aria-hidden', 'true');
          star.textContent = ' *';
          label.appendChild(star);
        }
        input.setAttribute('aria-required', 'true');
      }
    });

    // 3) Autocomplete sur champs usuels (FR)
    var prenom = findInputByLabelFragment(container, 'prénom') || findInputByLabelFragment(container, 'prenom');
    if (prenom) prenom.setAttribute('autocomplete', 'given-name');

    var nom = findInputByLabelFragment(container, 'nom');
    if (nom) nom.setAttribute('autocomplete', 'family-name');

    var tel = findInputByLabelFragment(container, 'téléphone') || findInputByLabelFragment(container, 'telephone') || container.querySelector('input[type="tel"]');
    if (tel) {
      tel.setAttribute('autocomplete', 'tel');
      // Pattern plus permissif : accepte formats FR métropole, mobile, international
      tel.setAttribute('pattern', '^(?:(?:\\+|00)33[\\s.-]?(?:\\(0\\)[\\s.-]?)?|0)[1-9](?:[\\s.-]?\\d{2}){4}$');
      tel.setAttribute('title', 'Format attendu : 01 23 45 67 89 ou +33 1 23 45 67 89');
    }

    // 3b) Supprimer aria-invalid="false" sur tous les champs (valeur par défaut inutile)
    $all(container, 'input[aria-invalid="false"], select[aria-invalid="false"], textarea[aria-invalid="false"]').forEach(function(field) {
      field.removeAttribute('aria-invalid');
    });

    var email = findInputByLabelFragment(container, 'email') || container.querySelector('input[type="email"]');
    if (email) email.setAttribute('autocomplete', 'email');

    // 4) Radio groups
    markRadioGroups(container);

    // 5) Simplifier RGPD
    simplifyRGPDCheckbox(container);

    // 6) Créer les fieldsets sémantiques conformes RGAA
    createProperFieldsets(container);

    // 7) Erreurs & messages (initial)
    attachErrorARIA(container);

    // 8) Observer : erreurs/messages ajoutés dynamiquement (validation Ajax, changements de page, etc.)
    var mo = new MutationObserver(function (muts) {
      var needs = false;
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.addedNodes && m.addedNodes.length) {
          needs = true; break;
        }
      }
      if (needs) {
        attachErrorARIA(container);
        enhanceHCaptchaLinks(container);
      }
    });
    mo.observe(container, { childList: true, subtree: true });
  }

  // =========================
  // Boot
  // =========================
  function init() {
    injectCSSOnce();
    labelBlankLinks(document);

    // Cible tous les conteneurs de formulaires Formidable
    var forms = $all(document, '[id^="frm_form_"][id$="_container"], .frm_forms');
    // Dédupliquer si sélecteurs recoupés
    var seen = new Set();
    forms.forEach(function (container) {
      if (seen.has(container)) return;
      seen.add(container);
      enhanceFormContainer(container);
    });

    // hCaptcha liens globaux (au cas où ils ne sont pas dans le conteneur)
    enhanceHCaptchaLinks(document);

    // Observer global pour liens hCaptcha ajoutés plus tard
    var observer = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.addedNodes && m.addedNodes.length) {
          for (var j = 0; j < m.addedNodes.length; j++) {
            var n = m.addedNodes[j];
            if (n.nodeType === 1) enhanceHCaptchaLinks(n);
          }
        }
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
